module.exports = __webpack_public_path__ + "img/playing.dedf32d0.gif";